
import Photos from 'src/components/Photos'

export default function ModalUnstyledDemo() {
  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  return (
    <>
      <Photos type='google-cloud' />
    </>
  )
}
